/* =============================================
   A&A Stainless: live part numbers for HulkApps options
   - Builds the part number as base SKU + one code per picked option,
     e.g. AA18-PTB-BZRD-S20-MT, and shows it in the product SKU line.
   - Repeats it in a "Part number" line under the options, next to Add to
     cart, since the SKU line at the top is off screen while choosing.
   - Adds it to the cart line as "Part number".
   - Reads ?part=FULL-PART-NUMBER (set by aa-part-lookup.js) and
     selects the matching options automatically.
   Option codes come from the SKU box on each option value in HulkApps.
   A choice with no SKU adds nothing (so "No Fog Lights" stays out of the
   part number). Codes are upper-cased and spaces are dropped. Codes may
   contain dashes; the ?part= reader matches the longest codes first.
   Works for any Hulk product with a SKU on the product or variant; nothing
   here needs editing when new products or options are added in Hulk.
   ============================================= */
(function () {
  'use strict';

  var MAX_WAIT_MS = 30000; // slow phones can take a while to load Hulk
  var root = null;
  var skuEl = null;
  var baseSku = '';
  var partInput = null;
  var partText = null;

  function labelFor(child) {
    return (child.getAttribute('data-conditional-value') || child.getAttribute('value') || child.textContent || '').trim();
  }

  function normalize(code) {
    return (code || '').replace(/\s+/g, '').toUpperCase();
  }

  // Code for one value of one option block ('' when the value has no SKU)
  function codeFor(optionEl, valueLabel) {
    var wanted = valueLabel.trim();
    var inputs = optionEl.querySelectorAll('.hulk_unique_sku');
    for (var i = 0; i < inputs.length; i++) {
      var id = (inputs[i].getAttribute('data-sku-identifier') || '').trim();
      // Button options carry the value in the name: properties[_SKU_Option(Value)]
      var name = inputs[i].getAttribute('name') || '';
      var inName = name.indexOf('(' + wanted + ')]') !== -1;
      if ((id === wanted || inName) && inputs[i].value) return normalize(inputs[i].value);
    }
    return '';
  }

  // All values of an option block: [{label, select()}]
  function valuesOf(optionEl) {
    var out = [];
    optionEl.querySelectorAll('.hulkapps_option_child').forEach(function (child) {
      out.push({
        label: labelFor(child),
        selected: function () { return child.classList.contains('button_selected') || child.classList.contains('swatch_selected'); },
        pick: function () { (child.querySelector('input') || child.querySelector('label') || child).click(); }
      });
    });
    optionEl.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (input) {
      if (input.closest('.hulkapps_option_child')) return;
      out.push({
        label: (input.value || '').trim(),
        selected: function () { return input.checked; },
        pick: function () { if (!input.checked) input.click(); }
      });
    });
    optionEl.querySelectorAll('select').forEach(function (select) {
      Array.prototype.forEach.call(select.options, function (opt) {
        if (!opt.value) return;
        out.push({
          label: (opt.getAttribute('data-conditional-value') || opt.value || opt.text).trim(),
          selected: function () { return select.value === opt.value; },
          pick: function () { select.value = opt.value; select.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      });
    });
    return out;
  }

  function optionBlocks() {
    return root ? Array.prototype.slice.call(root.querySelectorAll('.hulkapps_option')) : [];
  }

  function currentPart() {
    var codes = [];
    optionBlocks().forEach(function (optionEl) {
      valuesOf(optionEl).forEach(function (v) {
        if (v.selected()) {
          var code = codeFor(optionEl, v.label);
          if (code) codes.push(code);
        }
      });
    });
    return [baseSku].concat(codes).join('-');
  }

  // Dawn swaps the SKU element when the variant changes, so look it up each
  // time. If its text is not the part number we wrote, it is a new base SKU.
  var lastPart = '';
  function readBase() {
    skuEl = document.querySelector('product-info .product__sku, .product__sku');
    if (!skuEl) return;
    var t = '';
    skuEl.childNodes.forEach(function (n) { if (n.nodeType === 3) t += n.textContent; });
    t = t.trim();
    if (t && t !== lastPart) baseSku = t;
  }

  function render() {
    readBase();
    if (!baseSku) return;
    var part = currentPart();
    lastPart = part;
    if (skuEl) {
      var textNode = null;
      skuEl.childNodes.forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim()) textNode = n; });
      if (textNode) textNode.textContent = part;
      else skuEl.appendChild(document.createTextNode(part));
    }
    if (partInput) partInput.value = part;
    // Text node update, so the page watcher below does not loop on it
    if (partText && partText.nodeValue !== part) partText.nodeValue = part;
  }

  // ?part=AA18-PTB-BZRD-S20-MT  ->  select S20 and MT.
  // Longest codes are tried first, so a code like W-CA is read as one code.
  function applyPartFromUrl() {
    var part = new URLSearchParams(window.location.search).get('part');
    if (!part || !baseSku) return;
    part = normalize(part);
    var prefix = baseSku.toUpperCase() + '-';
    if (part.indexOf(prefix) !== 0) return;
    var rest = part.slice(prefix.length);

    var choices = [];
    optionBlocks().forEach(function (block) {
      valuesOf(block).forEach(function (v) {
        var code = codeFor(block, v.label);
        if (code) choices.push({ code: code, value: v });
      });
    });
    choices.sort(function (a, b) { return b.code.length - a.code.length; });

    while (rest) {
      var hit = null;
      for (var i = 0; i < choices.length; i++) {
        var c = choices[i].code;
        if (rest === c || rest.indexOf(c + '-') === 0) { hit = choices[i]; break; }
      }
      if (hit) {
        if (!hit.value.selected()) hit.value.pick();
        rest = rest.slice(hit.code.length + 1);
      } else {
        var dash = rest.indexOf('-');
        rest = dash === -1 ? '' : rest.slice(dash + 1); // unknown code: skip it
      }
    }
  }

  function setup() {
    readBase();
    if (!baseSku) return;

    // Inside the HulkApps box: Hulk builds its own add-to-cart request from
    // the fields in its box, so a field elsewhere in the form gets dropped.
    partInput = document.createElement('input');
    partInput.type = 'hidden';
    partInput.name = 'properties[Part number]';
    partInput.className = 'aa-part-number-input';
    root.appendChild(partInput);

    var line = document.createElement('div');
    line.className = 'aa-part-number-line';
    // Theme colors, so it fits both the dark and the light design
    line.style.cssText = 'margin:12px 0 0;padding:10px 14px;background:rgba(var(--color-foreground),0.04);' +
      'border:1px solid rgba(var(--color-foreground),0.15);border-left:3px solid #cc0000;border-radius:4px;' +
      'font-size:1.4rem;line-height:1.4;color:rgba(var(--color-foreground),0.75);';
    var label = document.createElement('span');
    label.textContent = 'Part number: ';
    var value = document.createElement('strong');
    value.style.cssText = 'color:rgb(var(--color-foreground));letter-spacing:0.03em;overflow-wrap:anywhere;';
    partText = document.createTextNode(baseSku);
    value.appendChild(partText);
    line.appendChild(label);
    line.appendChild(value);
    root.appendChild(line);

    root.addEventListener('click', function () { setTimeout(render, 60); });
    root.addEventListener('change', function () { setTimeout(render, 60); });
    // Variant change (size buttons): Dawn re-renders the SKU line
    var info = document.querySelector('product-info');
    if (info && window.MutationObserver) {
      new MutationObserver(function () { setTimeout(render, 60); }).observe(info, { childList: true, subtree: true });
    }

    applyPartFromUrl();
    setTimeout(render, 120);
  }

  var started = Date.now();
  (function waitForHulk() {
    root = document.querySelector('.hulkapps_product_options');
    if (root && root.querySelector('.hulkapps_option')) return setup();
    if (Date.now() - started < MAX_WAIT_MS) setTimeout(waitForHulk, 200);
  })();
})();
